import React from 'react';
import {
  View,
} from 'react-native';
import {
  Android,
} from '../../../../utils/DictionaryManagementUtils';
import EnableKeyboardIosFP from './EnableKeyboardIosFP';
import EnableKeyboardAndroidFP from './EnableKeyboardAndroidFP';

//= ========================================================================
const EnableKeyboardFP = ({
  globJSON,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <View>
    {simPlatform === Android ? (
      <EnableKeyboardAndroidFP
        globJSON={globJSON}
        language={language}
        simPlatform={simPlatform}
        slideshowRefs={slideshowRefs}
      />
    ) : (
      <EnableKeyboardIosFP
        globJSON={globJSON}
        language={language}
        simPlatform={simPlatform}
        slideshowRefs={slideshowRefs}
      />
    )}
    {!globJSON.configurations.onboarding.announcement.enable_keyboard_activation_flow && (
    <View style={{
      width: 240,
      height: simPlatform === Android ? 427 : 520,
      marginTop: 30,
      marginLeft: 0,
      position: 'absolute',
      backgroundColor: '#fff',
      opacity: 0.5,
    }}
    />
    )}
  </View>

);
export default EnableKeyboardFP;
